
import { Publisher, fileDocumentLicenseOptions } from '@/model';
import Vue from 'vue';

export default Vue.extend({
  name: 'PublishersView',

  props: {
    loading: { type: Boolean, default: false },
    publishers: { type: Array as () => Publisher[], required: false },
  },

  data() {
    return {
      edit: false,
      editItem: {} as Partial<Publisher>,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Author/s', value: 'name' },
        { text: 'Author Short', value: 'shortName' },
        { text: 'Geo, Publisher/s', value: 'geography' },
        { text: 'License', value: 'license' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },

  computed: {
    licenseOptions(): typeof fileDocumentLicenseOptions | undefined {
      return fileDocumentLicenseOptions;
    },
  },

  methods: {
    newPublisher() {
      this.edit = true;
      this.editItem = { id: 0 } as Partial<Publisher>;
    },
    editPublisher(publisher: Publisher) {
      this.edit = true;
      this.editItem = { ...publisher };
    },
    save() {
      this.$emit('save', this.editItem);
      this.edit = false;
    },
    close() {
      this.edit = false;
      this.editItem = {} as Publisher;
    },
  },

});
